import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/QAQC/QAQCAreaPage/constants';
import makePage from 'modules/makePage';
import * as constants from './constants';
import { QAQCReportPageParams } from './constants';
import useQAQCReportQueries, { QAQCReportQueries } from './useQAQCReportQueries';

const QAQCReportPage = lazyWithSuspense(() => import('./QAQCReportPage'));

const page: Page<QAQCReportPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: false,
  component: makePage<QAQCReportPageParams, QAQCReportQueries>({
    pageDataHook: useQAQCReportQueries,
    WrappedPage: QAQCReportPage,
    titleFn: () => i18n._(constants.TITLE),
    parentPathTemplate: parentConstants.BREAKING_SCHEDULES_ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
  }),
};

export default page;
